import { useRef } from "react";
import { useState, Dispatch, ReactPortal, ReactElement } from "react";
import { createPortal } from "react-dom";
import { className } from "../shared/helpers";

export interface TooltipSetup
{
    position: { x: number; y: number };
    content: string | ReactElement | null;
    customClassName?: string;
}

interface UseTooltip
{
    setupTooltip: Dispatch<TooltipSetup | null>;
    clearTooltip: () => void;
    Tooltip: () => ReactPortal;
}

export function useTooltip(): UseTooltip
{
    const clearTimeoutRef = useRef<number>(null as any);
    const [tooltipSetup, setupTooltip] = useState<TooltipSetup | null>(null);

    function clearEventTimeout()
    {
        if (clearTimeoutRef.current)
            clearTimeout(clearTimeoutRef.current);
    }

    function clearTooltip(): void
    {
        clearEventTimeout();
        clearTimeoutRef.current = window.setTimeout(() => setupTooltip(null), 300);
    }

    function Tooltip(): ReactPortal
    {
        if (!tooltipSetup) return null as any;

        return createPortal(
            <div
                id="tooltip"
                onMouseEnter={clearEventTimeout}
                onMouseLeave={() => setupTooltip(null)}
                {...className("custom-tooltip", tooltipSetup.customClassName)}
                style={{
                    ["--tooltip-top" as string]: `${tooltipSetup.position.y}px`,
                    ["--tooltip-left" as string]: `${tooltipSetup.position.x}px`
                }}
            >
                {tooltipSetup.content}
            </div>,
            document.body
        );
    }

    return { setupTooltip, clearTooltip, Tooltip };
}